import { Button } from "@controls";
import { useMemberPath } from "@src/modules/member/hooks/use-member-path";
import { DASHBOARD_PATH } from "@src/modules/member/modules/main/router/paths";
import { NotFoundDoorAndConfusedPenguin } from "raya-lucaria/illustrations";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { path } = useMemberPath();

  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="flex flex-col items-center gap-6 max-w-md px-4 text-center">
        <div className="w-full max-w-[300px]">
          <NotFoundDoorAndConfusedPenguin />
        </div>
        <h2 className="text-xl font-semibold text-gray-800">
          {t("pageNotFound")}
        </h2>
        <p className="text-gray-500">{t("notFound")}</p>
        <Button type="button" onClick={() => navigate(path(DASHBOARD_PATH()))}>
          {t("takeMeHome")}
        </Button>
      </div>
    </div>
  );
}
